import { h } from 'preact';
export const CornerDownRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "15 10 20 15 15 20" }),
        h("path", { d: "M4 4v7a4 4 0 0 0 4 4h12" })));
};
//# sourceMappingURL=corner-down-right.js.map